<template>
  <v-row>
    <v-col cols="12">
      <vuetify-table
        :headers="headers"
        :apiURL="apiURL"
        :title="title"
        :back="false"
        backURL="dealers"
        permisosNuevoRegistro="agregar_usuario_sistema"
      >
      <template v-slot:actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-if="can('actualizar_usuario_sistema')"
                :color="themeColor"
                @click="editItem(item)"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-if="can('eliminar_usuario_sistema')"
                :color="themeColor"
                @click="openModalDelete(item)"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
          <v-tooltip v-if="!restoringPassword" bottom >
            <template v-slot:activator="{ on }">
              <v-icon
                v-if="can('restablecer_contrasena_usuario_sistema')"
                :color="themeColor"
                @click="openModalPass(item)"
                v-on="on"
              >
                mdi-lock
              </v-icon>
            </template>
            <span>Restablecer contraseña</span>
          </v-tooltip>
           <v-progress-circular
            v-else
            indeterminate
            :color="themeColor"
          ></v-progress-circular>
        </template>
      </vuetify-table>
      <v-dialog
        v-model="dialog"
        max-width="620"
      >
        <v-card>
          <v-card-title class="headline">
            ¿Estás seguro de que quieres eliminar este registro?
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="red darken-1"
              text
              @click="dialog = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="toggleStatus"
              @click.prevent="deleteItem()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogPass"
        max-width="650"
      >
        <v-card>
          <v-card-title class="headline">
            ¿Estás seguro de que quieres restablecer la contraseña de este registro?
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="red darken-1"
              text
              @click="dialogPass = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="toggleStatusPass"
              @click.prevent="resetPass()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import VuetifyTable from '~/components/VuetifyTable';

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('systemUsers') };
  },
  components: {
    VuetifyTable,
  },
  props: {
    id: { default: '0' },
    action: { default: '' },
    message: { default: '' },
  },
  data: () => ({
      dialog: false,
      toggleStatus: false,
      dialogPass: false,
      toggleStatusPass: false,
      restoringPassword: false,
      headers: [
        {
          text: 'Nombre',
          value: 'name',
          align: 'left',
        }, {
          text: 'Usuario',
          value: 'email',
          align: 'left',
        },
        {
          text: 'Activo',
          value: 'active',
          align: 'left',
        },
        {
          text: 'Acciones',
          value: 'action',
          sortable: false,
        },
      ],
      title: 'Usuarios de sistema',
  }),
  computed: {
    apiURL() {
      return `/api/catalogs/dealers/${this.user.dealer_id}/users`;
    },
    ...mapGetters({
      user: 'auth/user',
      themeColor: 'theme/themeColor',
    }),
  },
  mounted() {
    if (!this.can('cambiar_estado_usuario_sistema')) {
      this.headers.splice(this.headers.findIndex(({ text }) => text === 'Activo'), 1);
    }
    if (!this.can('actualizar_usuario_sistema') && !this.can('eliminar_usuario_sistema')) {
      this.headers.splice(this.headers.findIndex(({ text }) => text === 'Acciones'), 1);
    }
  },
  methods: {
    editItem(item) {
      const editedItem = { ...item };
      this.$router.push({ path: `${this.$router.currentRoute.path}/${this.user.dealer_id}/${editedItem.id}/editar`, params: { id: editedItem.id } });
    },
    openModalDelete(item) {
      this.dialog = true;
      this.item = item;
    },
    deleteItem() {
      const url = `${this.apiURL}/${this.item.id}`;
      window.axios.delete(url)
      .then((response) => {
        this.$store.dispatch('notifications/show', {
          message: response.data.message,
          type: response.data.type,
        });
        this.dialog = false;
        this.$router.go(0);
      });
    },
    openModalPass(item) {
      this.dialogPass = true;
      this.item = item;
    },
    resetPass() {
      this.restoringPassword = true;
      window.axios.put(`/api/catalogs/dealers/${this.item.id}/reset_password`, {
          id: this.item.id,
      }).then(() => {
        this.restoringPassword = false;
      });
      this.dialogPass = false;
    },
    reset() {
        this.$refs.form.reset();
      },
  },
};
</script>
